import {GtmItemModel} from "./gtmItemModel";

export class GtmEventModel {
    /**
     * @type {string}
     */
    type = 'event';

    /**
     * @type {string}
     */
    currency = 'EUR';

    /**
     * @type {number}
     */
    value = 0;

    /**
     * @type {string}
     */
    coupon = '';

    /**
     * @type {string}
     */
    shipping_tier = '';

    /**
     * @type {string}
     */
    payment_type = '';

    /**
     * @type {GtmItemModel[]}
     */
    items = [];

    /**
     * @returns {{}}
     */
    getEventData() {
        let event = {};

        if (this.currency) {
            event.currency = this.currency;
        }

        if (this.coupon) {
            event.coupon = this.coupon;
        }

        // Handle value calculation
        if (this.value === 0) {

            event.value = this.getValueFromItems();

        } else {

            event.value = this.value;
        }

        if (this.shipping_tier) {
            event.shipping_tier = this.shipping_tier;
        }

        if (this.payment_type) {
            event.payment_type = this.payment_type;
        }

        if (this.items.length > 0) {
            event.items = this.items.map((item, index) => item.getitemData(index));
        }

        return event;
    }

    /**
     * @param gtmItem {GtmItemModel}
     * @returns {void}
     */
    addItem(gtmItem) {

        if (!(gtmItem instanceof GtmItemModel)) {

            console.trace('Invalid GTM item');

            return;
        }

        this.items.push(gtmItem);
    }

    /**
     * @returns {number}
     */
    getValueFromItems() {
        // Iterate all items and sum up (prices*amount)
        let value = 0;

        this.items.forEach(item => {
            value += item.price * item.quantity;
        });

        if (value > 0) {

            return value;
        }

        return 1;
    }

    /**
     * @returns {boolean}
     */
    isValid() {
        let value = this.getValueFromItems()

        if (this.currency === '') {
            return false;
        }

        if (value === 0) {
            return false;
        }

        if (this.items.length === 0) {
            return false;
        }

        return true;
    }
}